import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'
import { encodeId } from 'helper/sqids'
let resError = ''
// export const getRole = async ({ token }) => {
//   try {
//     return await clientPublic
//       .get(`role?limit=99999999`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         return response
//       })
//       .catch((error) => {
//         const { response } = error
//         if ([401, 403].includes(response.status)) {
//           return handleError(response)
//         }
//         return response
//       })
//   } catch (error) {
//     console.error('error', error)
//     return error
//   }
// }

export const getPermissionControl = async ({ token }) => {
  try {
    return await clientPublicService
      .get(`/core/permission/string-return`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getRole = async ({ token }) => {
  try {
    return await clientPublicService
      .get(`/core/management/permission/role-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// export const getMenuList = async ({ token }) => {
//   try {
//     return await clientPublic
//       .get(`role/menu?limit=20`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         return response
//       })
//       .catch((error) => {
//         const { response } = error
//         if ([401, 403].includes(response.status)) {
//           return handleError(response)
//         }
//         return response
//       })
//   } catch (error) {
//     console.error('error', error)
//     return error
//   }
// }

export const getMenuList = async ({ token }) => {
  try {
    return await clientPublicService
      .get(`/core/management/permission/menu-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// export const getMappingRole = async ({ token, id }) => {
//   try {
//     return await clientPublic
//       .get(`role/mapping/${id}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         return response
//       })
//       .catch((error) => {
//         const { response } = error
//         if ([401, 403].includes(response.status)) {
//           return handleError(response)
//         }
//         return response
//       })
//   } catch (error) {
//     console.error('error', error)
//     return error
//   }
// }

export const getMappingRole = async ({ token, id }) => {
  try {
    const encodedId = encodeId(id)

    return await clientPublicService
      .get(`/core/management/permission/${encodedId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// export const adminAddRole = async ({ params, token }) => {
//   try {
//     return await clientPublic
//       .post(`role`, params, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         return response
//       })
//       .catch((error) => {
//         const { response } = error
//         if ([401, 403].includes(response.status)) {
//           return handleError(response)
//         }
//         return response
//       })
//   } catch (error) {
//     console.error('error', error)
//     return resError
//   }
// }

export const adminAddRole = async ({ params, token }) => {
  try {
    return await clientPublicService
      .post(`/core/management/permission`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const mappingRole = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`role/mapping`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
// export const updateRole = async ({ params, token }) => {
//   try {
//     return await clientPublic
//       .put(`role/${params.id}`, params, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         return response
//       })
//       .catch((error) => {
//         const { response } = error
//         if ([401, 403].includes(response.status)) {
//           return handleError(response)
//         }
//         return response
//       })
//   } catch (error) {
//     console.error('error', error)
//     return resError
//   }
// }

export const updateRolePermission = async ({ id, payload, token }) => {
  try {
    const encodedId = encodeId(id)
    return await clientPublicService
      .put(`/core/management/permission/${encodedId}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

// export const deleteRolepermission = async ({ id, token }) => {
//   try {
//     return await clientPublic
//       .delete(`role/${id}`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         return response
//       })
//       .catch((error) => {
//         const { response } = error
//         if ([401, 403].includes(response.status)) {
//           return handleError(response)
//         }
//         return response
//       })
//   } catch (error) {
//     console.error('error', error)
//     return error
//   }
// }

export const deleteRolepermission = async ({ id, token }) => {
  try {
    const encodedId = encodeId(id)
    return await clientPublicService
      .delete(`/core/management/permission/${encodedId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}